<template>
  <div class="app" :style="style">
    <div v-if="!closeLoading" class="container">
      <!--S Loading-->
      <div class="loading">
        <div class="loading-point" />
      </div>
    <!--E Loading-->
    </div>
    <root :site-data="renderData" />
  </div>
</template>

<script>
import Root from './components/root.vue'
import { renderBg } from '@/utils/tools'
export default {
    'name': 'App',
    'data': () => ({
        'renderData': { 'pageData': [], 'fixedData': [] },
        'initFlag': false,
        'globalConfig': { 'editing': false, 'unit': 'rem' },
        'componentMap': new Map(),
        'actionPageBg': {}
    }),
    provide() {
        return { 'globalConfig': this.globalConfig }
    },
    'computed': {
        style() {
            const { rect = { 'width': 375 }, background = {}} = this.renderData?.options?.style || {}
            return {
                'width': rect.width + this.globalConfig.unit,
                'height': rect.height + this.globalConfig.unit,
                ...renderBg(background, this.$root.isSuWebp),
                ...this.actionPageBg
            }
        },
        closeLoading() {
            return this.$root.closeLoading
        }
    },
    created() {
        if (this.DATA) {
            this.renderData = this.DATA
            // bodyStyle.backgroundColor = '#333'
        }
        this.$bus.$on('setPagebg', (bg) => {
            let { background = {}} = this.renderData?.options?.style || {}
            background = { ...background, ...bg }
            this.actionPageBg = {
                ...renderBg(background, this.$root.isSuWebp)
            }
        })
    },
    'components': { Root },
    mounted() {
        const autoCloseLoading = this.renderData?.options?.basic?.autoCloseLoading
        if (autoCloseLoading || autoCloseLoading !== false) {
            this.$root.closeLoading = true
        }
        // eslint-disable-next-line no-undef
        this.$bus.$on('setProductBg', ({ color, image } = bg) => {
            // eslint-disable-next-line no-unused-vars
            let background = this.renderData.options.style.background
            background = { ...background, ...{ image, color, imageType: 'image' }}
        })
    }
}
</script>

<style lang="scss">
html body{
    box-sizing: content-box;
}
.app{
    background-color: #ffffff;
    margin: 0 auto;
    position: relative;
}
.container {
    width: 100vw;
    overflow-x: hidden;
    position: relative;
  }

  .loading {
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999999999;
  }
  .apiloading{
    background: rgba(255,255,255, 0.4);
    z-index: 99999;
  }

  @mixin point-style {
    display: block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: rgba(255, 173, 60, 1);
    animation: loading-point 0.6s infinite ease-in-out;
  }

  .loading-point {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    @include point-style;
    transform: translateX(-19px);

    &::after {
      content: " ";
      @include point-style;
      position: absolute;
      right: -19px;
      top: 0;
      animation-delay: 0.2s;
    }

    &::before {
      content: " ";
      @include point-style;
      position: absolute;
      right: -38px;
      top: 0;
      animation-delay: 0.4s;
    }
  }

  @keyframes loading-point {
    0% {
      background-color: rgba(255, 173, 60, 1);
    }
    100% {
      background-color: rgba(255, 173, 60, 0.3);
    }
  }
  .container {
    width: 100vw;
    overflow-x: hidden;
    font-size: 12px;
    min-height: 100vh;
  }
</style>

